// React
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Material UI
import {
  ClickAwayListener,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grow,
  Typography,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  MenuRounded,
  MenuOpenRounded,
  DashboardRounded,
  LocationCityRounded,
  DomainAddRounded,
  AddBusinessRounded,
  PeopleAlt,
} from "@mui/icons-material";

// Components
import { styles, StyledDrawer } from "./styles";
import { cardShadow } from "Constants/ColourConstants";

const NavigationDrawer = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const DrawerListItem = ({ label, path, icon }) => {
    const location = useLocation();

    return (
      <ListItem
        key={label}
        disablePadding
        sx={{ display: "block" }}
        onClick={() => handleNavigation(path)}
      >
        <Tooltip
          title={label}
          placement="right"
          arrow
          disableHoverListener={drawerOpen}
        >
          <ListItemButton sx={styles.listItemButton(drawerOpen)}>
            <ListItemIcon
              sx={styles.listItemIcon(drawerOpen, location.pathname === path)}
            >
              {icon}
            </ListItemIcon>
            <ListItemText
              primary={label}
              sx={{ opacity: drawerOpen ? 1 : 0 }}
            />
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  };

  const DrawerDivider = ({ title }) => {
    return (
      <Divider aria-hidden="true" textAlign="left">
        {drawerOpen && (
          <Grow in={drawerOpen}>
            <Typography sx={{ fontSize: 13, textAlign: "left" }}>
              {title}
            </Typography>
          </Grow>
        )}
      </Divider>
    );
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (drawerOpen) {
          setDrawerOpen(false);
        }
      }}
    >
      <StyledDrawer
        variant="permanent"
        open={drawerOpen}
        slotProps={{ paper: { sx: { boxShadow: cardShadow } } }}
      >
        <List
          sx={{
            display: "flex",
            justifyContent: drawerOpen ? "flex-end" : "center",
            px: drawerOpen ? 1 : 0,
          }}
        >
          <IconButton
            onClick={() => {
              setDrawerOpen(!drawerOpen);
            }}
          >
            {drawerOpen && theme.direction !== "rtl" ? (
              <MenuOpenRounded />
            ) : (
              <MenuRounded />
            )}
          </IconButton>
        </List>
        <List>
          <DrawerListItem
            label="Home Page"
            path="/"
            icon={<DashboardRounded />}
          />
        </List>
        <DrawerDivider title="Management" />
        <List>
          <DrawerListItem
            label="Client Management"
            path="/ClientManagement"
            icon={<LocationCityRounded />}
          />
          <DrawerListItem
            label="User Management"
            path="/UserManagement"
            icon={<PeopleAlt />}
          />
        </List>
        <DrawerDivider title="Add Client or Clinic" />
        <List>
          <DrawerListItem
            label="Add Client"
            path="/AddClient"
            icon={<DomainAddRounded />}
          />
          <DrawerListItem
            label="Add Clinic"
            path="/AddClinic"
            icon={<AddBusinessRounded />}
          />
        </List>
      </StyledDrawer>
    </ClickAwayListener>
  );
};

export default NavigationDrawer;
